
import React from 'react';
import './App.css';
import mario from './Super_Mario_64_Mario.PNG'
import goodNews from './sm64_happy_message.wav'
import soLongBowser from './sm64_mario_so_long_bowser.wav'
import thwomp from './sm64_thwomp.wav'
function App() {
  const soundRef__goodNews = React.createRef()
  const soundRef__soLongBowser = React.createRef()
  const soundRef__thwomp = React.createRef()
  const playGoodNews = () => {
    soundRef__goodNews.current.play()
  }
  const playSoLongBowser = () => {
    soundRef__soLongBowser.current.play()
  }
  const playThwomp = () => {
    soundRef__thwomp.current.play()
  }
  return (
    <div className="App">
        <h1 onClick={playGoodNews}>Make the Mushroom Kingdom Great Again</h1>
        <div onClick={playGoodNews}>
        <img src={mario} />
        <a  
          className="App-link"
          href="https://basescan.org/address/0x6800139d00d58325d4e6fed622a9d85e476dbca5#code"
          target="_blank"
          rel="noopener noreferrer"
        >
          View Contract on Basescan
        </a>
        <br/>
        <img src={mario} />
        <a  
          className="App-link"
          href="https://dexscreener.com/base/0x1f6be3a24d7d02b05362664e4c6be7e112b3166f"
          target="_blank"
          rel="noopener noreferrer"
        >
          View Chart on dexscreener
        </a>
        <br/>
        <img src={mario} />
        <a  
          className="App-link"
          href="https://app.uniswap.org/swap"
          target="_blank"
          rel="noopener noreferrer"
        >
          Swap on Uniswap
        </a>
        
        </div>
        <div onClick={playGoodNews}>
        <img src={mario} />
        <a
          className="App-link"
          href="https://x.com/_racistmario"
          target="_blank"
          rel="noopener noreferrer"
        >
          Follow Racist Mario on X
        </a>
        </div>
        <p>CA: 0x6800139d00d58325d4e6fed622a9d85e476dbca5</p>
        <h2 onClick={playGoodNews}>Roadmap</h2>
        <p>The twinks at trenches tried to rug us but we relaunched on Base.</p>
        <p onClick={playGoodNews}>Q1 - Build wall around Mushroom Kingdom</p>
        <p onClick={playSoLongBowser}>Q2 - Round up and deport the koopas</p>
        <p onClick={playThwomp}>Q3 - Bang Peach in peace</p>
        <audio ref={soundRef__goodNews}>
        <source src={goodNews} type="audio/wav" />
        Your browser does not support the audio element.
      </audio>
      <audio ref={soundRef__soLongBowser}>
        <source src={soLongBowser} type="audio/wav" />
        Your browser does not support the audio element.
      </audio>
      <audio ref={soundRef__thwomp}>
        <source src={thwomp} type="audio/wav" />
        Your browser does not support the audio element.
      </audio>
    </div>
  );
}

export default App;
